"use client";
import React, { useEffect, useRef, useState } from 'react';
import styles from '../styles/pantalla_inicio.module.css';
import Sidebar, { useSidebar } from '../components/Sidebar';
import progStyles from '../styles/PantallaDeProgramasAcademicos.v2.module.css';
import HeaderGlobal from '../components/HeaderGlobal';
import { useAuth } from '../api/AuthContext';
import { useNavigate } from 'react-router-dom';

function PantallaDeInicio() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const toggleRef = useRef(null);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { isCollapsed } = useSidebar();

  // Close on outside click or Escape
  useEffect(() => {
    if (!isMenuOpen) return;
    const onDocClick = (e) => {
      const menuEl = menuRef.current;
      const toggleEl = toggleRef.current;
      if (!menuEl || !toggleEl) return;
      if (!menuEl.contains(e.target) && !toggleEl.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setIsMenuOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [isMenuOpen]);
  console.log('user en pantalla_inicio:', user);
  return (
    <div className={progStyles.mainContainer}>
      <div className={`${progStyles.layout} ${isCollapsed ? progStyles.sidebarCollapsedLayout : ''}`} style={{minHeight: '100dvh', height: '100%', overflow: 'hidden'}}>
        <div className={progStyles.sidebarColumn}>
          <Sidebar />
        </div>
        <div className={progStyles.contentColumn}>
          <HeaderGlobal />
          <main className={progStyles.mainContent} style={{flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column'}}>
            <div className={progStyles.contentArea} style={{flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column'}}>
              <div className={styles.dashboard} role="main" style={{flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column'}}>
                <div className={styles.contentWrapper} style={{flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column'}}>
                  <div className={styles.topSection}>
            {/* Welcome Section */}
            <section className={styles.welcomeSection}>
              <div className={styles.brandSection}>
                <img
                  src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/d298578f8bf0875078cc38afceee1556b59d1a2b?placeholderIfAbsent=true"
                  alt="Universidad Lux Logo"
                  className={styles.brandLogo}
                />
                <div className={styles.brandName}>
                  <h1 className={styles.universityName}>UNIVERSIDAD </h1>
                  <div className={styles.brandDivider} />
                  <span className={styles.luxName}>LUX</span>
                </div>
              </div>
              <div className={styles.welcomeText}>
                <p className={styles.welcomeMessage}>Bienvenido al Sistema Lux,</p>
                <h2 className={styles.userTitle}>{user?.rol_nombre || user?.rol || 'Usuario'}</h2>
              </div>
            </section>

            {/* User Profile Menu */}
            {isMenuOpen && (
              <aside
                ref={menuRef}
                id="profileMenuPanel"
                className={styles.profileMenu}
                role="complementary"
                aria-label="Menú de usuario"
              >
                <div className={styles.menuContainer}>
                  <div className={styles.userSection}>
                    <img
                      src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/cd367352-a3aa-4ee9-ab0b-8ed6dd500b99?placeholderIfAbsent=true"
                      alt="User avatar"
                      className={styles.avatar}
                    />
                    <div className={styles.menuUserDetails}>
                      <h3 className={styles.menuUserName}>{user?.nombre_completo || user?.email || 'Usuario'}</h3>
                      <button
                        className={styles.expandButton}
                        aria-label="Expand user details"
                      >
                        <img
                          src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/e5e2df3a1e5d0e15e303cf572b0ccd3f081cca3c?placeholderIfAbsent=true"
                          alt=""
                          className={styles.expandIcon}
                        />
                      </button>
                      <p className={styles.menuUserRole}>{user?.email || ''}</p>
                    </div>
                  </div>
                  <div className={styles.menuDivider} role="separator" />
                  <nav className={styles.menuItems} role="navigation" aria-label="User menu">
                    <a href="/perfil" className={styles.menuItem}>
                      <img
                        src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/d322d3bbf7e60f414f2bfdc41327c993367eaf88?placeholderIfAbsent=true"
                        alt=""
                        className={styles.menuIcon}
                      />
                      <span>Perfil</span>
                    </a>
                    <a href="/soporte" className={styles.menuItem}>
                      <img
                        src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/c229a3950373c9a4baf0a6b5fcc8b6e19924ace4?placeholderIfAbsent=true"
                        alt=""
                        className={styles.supportIcon}
                      />
                      <span>Soporte</span>
                    </a>
                  </nav>
                  <div className={styles.bottomDivider} role="separator" />
                  <button
                    className={styles.logoutButton}
                    onClick={async () => {
                      await logout();
                      navigate('/login');
                    }}
                  >
                    <img
                      src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/c6b1221cbf2dcf450a14bccb0950432cbd6ed7c9?placeholderIfAbsent=true"
                      alt=""
                      className={styles.logoutIcon}
                    />
                    <span>Cerrar Sesión</span>
                  </button>
                </div>
              </aside>
            )}
                  </div>
                </div>

                {/* Footer */}
                <footer className={styles.footer}>
                  <p className={styles.copyright}>
                    © 2025 Universidad Lux. Todos los derechos reservados.
                  </p>
                </footer>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default PantallaDeInicio;
